import React from "react";
import { useAuth } from "../../context/AuthContext";

const RoleBadge = ({ role, className = "" }) => {
  const { getRoleDisplayName, getRoleColor } = useAuth();

  const colors = {
    super_admin:
      "bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400",
    project_manager:
      "bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400",
    sub_manager:
      "bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400",
    foreman:
      "bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400",
    worker:
      "bg-slate-100 text-slate-700 dark:bg-slate-900/30 dark:text-slate-400",
  };

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${colors[role] || colors.worker} ${className}`}
    >
      {getRoleDisplayName(role)}
    </span>
  );
};

export default RoleBadge;
